import { render, staticRenderFns } from "./ScreenshotsPreview.vue?vue&type=template&id=bdf2b398&"
import script from "./ScreenshotsPreview.vue?vue&type=script&lang=js&"
export * from "./ScreenshotsPreview.vue?vue&type=script&lang=js&"
import style0 from "./ScreenshotsPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports